import $ from 'jquery';
window.addEventListener('px-ready',function() {
    setTimeout(function(){
        $('[px-create-image]').each(function(){
            //console.log($(this).attr("px-create-image"));
            $(this).append('<img src="'+$(this).attr("px-create-image")+'" />');
        })
        setTimeout(function(){
            $(window).trigger('resize')
        },100);
    },100);
})